import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ydvwmgrd6: FaireBrandEntity = {
  token: "b_7ydvwmgrd6",
  type: "brand",
  name: "NOAH MARION",
  avatarUrl:
    "https://cdn.faire.com/fastly/083288f8bfbcd09a50e546382ac08351890b2429b5820ac382ada4810b91b7b3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6e4c29cba59be168bf584733196d732eaef6d7fd14ac51ce50e0acba913aac6a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/083288f8bfbcd09a50e546382ac08351890b2429b5820ac382ada4810b91b7b3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6e4c29cba59be168bf584733196d732eaef6d7fd14ac51ce50e0acba913aac6a.jpeg",
  location: "Austin, TX, USA",
  minimumOrderDollars: 175,
  rating: 4.5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Since 2006 Noah Marion has focused on untreated, undyed natural vegetable tanned leather in order to allow the user to personally bring the design to life.\nEach person will interact with their wallet, bag or belt differently and therefore it will truly become yours with use. A water spot here, a coffee stain there just adds to the character of the piece. Please keep this in mind when using your goods, they will change, they will age, they will darken. This is the goal, they get better and better with age.\nAt Noah Marion we make handcrafted products that are meant to get better the longer you own them. Your wallet, your belt, your favorite hat, your morning coffee mug. Life is better when lived with intention and we hope to bring a little more of that into people's lives.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:05.946Z",
    importedBy: "entity-db-cli",
  },
};
